module.exports = __webpack_public_path__ + "img/34.d21fa7dd.png";